import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import premierLogo from "../../../assessts/premier-logo.png";
import "./ViewInvoice.css";

function InvoiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/getInvoiceById/${id}`);
        if (response.data.success) setInvoice(response.data.invoice);
      } catch {
        alert("Could not load invoice details.");
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  if (loading) return <div className="invoice-view-state">Loading...</div>;
  if (!invoice) return <div className="invoice-view-state">Invoice not found.</div>;

  const total = Number(invoice.totalAmount || 0);
  const taxAmount = Number(invoice.taxAmount || 0);
  const subTotal =
    invoice.subTotalAmount !== undefined
      ? Number(invoice.subTotalAmount || 0)
      : Math.max(total - taxAmount, 0);
  const paid = Number(invoice.paidAmount || 0);
  const balance =
    invoice.remainingAmount !== undefined
      ? Number(invoice.remainingAmount || 0)
      : Math.max(total - paid, 0);
  const invoiceDate = invoice.date ? String(invoice.date).slice(0, 10) : "-";
  const dueDate = invoice.dueDate ? String(invoice.dueDate).slice(0, 10) : "-";
  const items = Array.isArray(invoice.projects) && invoice.projects.length
    ? invoice.projects
    : [{ name: "Service", amount: total }];

  const currMap = { INR: "Rs ", USD: "$", EUR: "€", GBP: "£", CAD: "CA$" };
  const currSym = currMap[invoice.currency] || "Rs ";

  return (
    <div className="invoice-view-page" style={{ background: "#2b2b2b", padding: "20px" }}>
      <div className="invoice-view-topbar">
        <button className="invoice-back-btn" onClick={() => navigate(-1)}>
          Back to List
        </button>
      </div>
      <div style={{ maxWidth: 800, margin: "0 auto", background: "#fff", padding: 26, color: "#1f2937" }}>
        <h1 style={{ textAlign: "center", color: "#2476c2", marginBottom: 24 }}>INVOICE</h1>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
          <div>
            <p style={{ margin: 0, fontWeight: 700 }}>Premier Webtech</p>
            <p style={{ margin: "6px 0" }}>India</p>
            <p style={{ margin: 0 }}>Email: support@premierwebtech.com</p>
          </div>
          <img src={premierLogo} alt="Premier Webtech" style={{ width: 170, objectFit: "contain" }} />
        </div>

        <hr style={{ borderColor: "#add4ea", opacity: 1 }} />

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
          <div>
            <p style={{ color: "#2476c2", fontWeight: 700, marginBottom: 10 }}>Bill To</p>
            <p style={{ margin: 0 }}>{invoice.clientName || "-"}</p>
          </div>
          <div>
            <p style={{ marginBottom: 8 }}><strong>Invoice No :</strong> {invoice.invoiceNumber || "-"}</p>
            <p style={{ marginBottom: 8 }}><strong>Invoice Date :</strong> {invoiceDate}</p>
            <p style={{ marginBottom: 0 }}><strong>Due Date :</strong> {dueDate}</p>
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 24 }}>
          <thead>
            <tr style={{ background: "#2476c2", color: "#fff" }}>
              <th style={{ padding: 10, textAlign: "left" }}>Sl</th>
              <th style={{ padding: 10, textAlign: "left" }}>Description</th>
              <th style={{ padding: 10, textAlign: "left" }}>Qty</th>
              <th style={{ padding: 10, textAlign: "left" }}>Rate</th>
              <th style={{ padding: 10, textAlign: "left" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p, i) => {
              const amount = Number(p?.amount || 0);
              return (
                <tr key={i} style={{ border: "1px solid #d1d5db" }}>
                  <td style={{ padding: 10 }}>{i + 1}</td>
                  <td style={{ padding: 10 }}>{p?.name || "Service"}</td>
                  <td style={{ padding: 10 }}>1</td>
                  <td style={{ padding: 10 }}>{currSym}{amount.toLocaleString()}</td>
                  <td style={{ padding: 10 }}>{currSym}{amount.toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
          <div>
            <p style={{ color: "#2476c2", fontWeight: 700, marginBottom: 8 }}>Payment Instructions</p>
            <p style={{ marginBottom: 8 }}>Pay via Bank / UPI</p>
            {invoice.clientGstNumber ? (
              <p style={{ marginBottom: 8 }}>GST Number: {invoice.clientGstNumber}</p>
            ) : null}
            {invoice.clientAccountNo ? (
              <p style={{ marginBottom: 8 }}>Account Number: {invoice.clientAccountNo}</p>
            ) : null}
            <p style={{ marginBottom: 0 }}>Amount Due: {currSym}{balance.toLocaleString()}</p>
          </div>
          <div style={{ border: "1px solid #add4ea", borderRadius: 8, minWidth: 260, padding: 10 }}>
            <p style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}><span>Sub Total</span><span>{currSym}{subTotal.toLocaleString()}</span></p>
            {taxAmount > 0 ? (
              <p style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <span>{invoice.taxName || "Tax"}</span>
                <span>{currSym}{taxAmount.toLocaleString()}</span>
              </p>
            ) : null}
            <p style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}><span>Total</span><span>{currSym}{total.toLocaleString()}</span></p>
            <p style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}><span>Paid</span><span>{currSym}{paid.toLocaleString()}</span></p>
            <p style={{ display: "flex", justifyContent: "space-between", marginBottom: 0, fontWeight: 700 }}><span>Balance</span><span>{currSym}{balance.toLocaleString()}</span></p>
          </div>
        </div>

        <p style={{ marginTop: 30, fontWeight: 700 }}>Payment Status: {invoice.status || "-"}</p>

        {invoice.payments && invoice.payments.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <h4 style={{ color: "#2476c2", marginBottom: 10 }}>Payment Details</h4>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f3f4f6", color: "#1f2937" }}>
                  <th style={{ padding: 10, textAlign: "left", border: "1px solid #d1d5db" }}>Date</th>
                  <th style={{ padding: 10, textAlign: "left", border: "1px solid #d1d5db" }}>Bank Name</th>
                  <th style={{ padding: 10, textAlign: "left", border: "1px solid #d1d5db" }}>Payment Method</th>
                  <th style={{ padding: 10, textAlign: "left", border: "1px solid #d1d5db" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoice.payments.map((payment, index) => (
                  <tr key={index}>
                    <td style={{ padding: 10, border: "1px solid #d1d5db" }}>{payment.date ? String(payment.date).slice(0, 10) : "-"}</td>
                    <td style={{ padding: 10, border: "1px solid #d1d5db" }}>{payment.bankName || "-"}</td>
                    <td style={{ padding: 10, border: "1px solid #d1d5db" }}>{payment.method || "-"}</td>
                    <td style={{ padding: 10, border: "1px solid #d1d5db" }}>{currSym}{Number(payment.amount || 0).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default InvoiceDetail;
